import { render, staticRenderFns } from "./Interfaces-Show.vue?vue&type=template&id=0b5563d7&"
import script from "./Interfaces-Show.vue?vue&type=script&lang=js&"
export * from "./Interfaces-Show.vue?vue&type=script&lang=js&"
import style0 from "./Interfaces-Show.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports